import { Component, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { CompanyRoleDTO } from '../../../../../../server/src/dto/company-role.dto';
import { OrganizationService } from '../../services/organization/organization.service';
import { LanguageService } from '../../services/language/language.service';

@Component({
  selector: 'app-company-role-select',
  templateUrl: './company-role-select.component.html',
  styleUrls: ['./company-role-select.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: CompanyRoleSelectComponent,
    multi: true,
  }],
})
export class CompanyRoleSelectComponent implements OnInit, ControlValueAccessor {
  private _onChange: (role: CompanyRoleDTO) => void;
  private _onTouched: (role: CompanyRoleDTO) => void;

  constructor(private _organizationService: OrganizationService,
              private _languageService: LanguageService) {
  }

  @Input()
  public displayOnly: boolean;

  @Input()
  public name: string;

  @Input()
  public placeholder: string;

  @Input()
  public unselectable: boolean;

  @Input()
  public companyRoles: CompanyRoleDTO[];

  @Input()
  public required: boolean;

  public isDisabled: boolean;

  public selectedCompanyRole: CompanyRoleDTO;

  async ngOnInit() {
    this.companyRoles = this.companyRoles || await this._organizationService.getCompanyRolesAsync();

    this.placeholder = this.placeholder || await this._languageService.getTranslationAsync('Common.Role');
  }

  public onInnerChange(change: string) {
    this.selectedCompanyRole = this.companyRoles.find(role => role.id === change);

    this._onTouched && this._onTouched(this.selectedCompanyRole);
    this._onChange && this._onChange(this.selectedCompanyRole);
  }

  public registerOnChange(fn: any): void {
    this._onChange = fn;
  }

  public registerOnTouched(fn: any): void {
    this._onTouched = fn;
  }

  public setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  public writeValue(companyRole: CompanyRoleDTO): void {
    this.selectedCompanyRole = companyRole;
  }
}
